<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="32" height="32" fill="#F5F5F5"/>
<g id="Profile_Edit">
<rect x="-40" y="-132" width="393" height="641" rx="8" fill="#F7F2E9"/>
<g id="Options Section">
<g id="Option Wrapper">
<g id="Option Container">
<rect x="-15.5" y="-11.5" width="344" height="55" rx="27.5" fill="white"/>
<rect x="-15.5" y="-11.5" width="344" height="55" rx="27.5" stroke="#DDDAD2"/>
<g id="Configuration Icon" clip-path="url(#clip0_1_5)">
<circle id="background" cx="16" cy="16" r="16" fill="#68706D"/>
<g id="settings" clip-path="url(#clip1_1_5)">
<g id="Group">
<path id="Vector" d="M25.52 17.2533C25.5733 16.8533 25.6 16.44 25.6 16C25.6 15.5733 25.5733 15.1466 25.5067 14.7466L28.2133 12.6399C28.4533 12.4533 28.52 12.0933 28.3733 11.8266L25.8133 7.39995C25.6533 7.10662 25.32 7.01328 25.0267 7.10662L21.84 8.38662C21.1733 7.87995 20.4667 7.45328 19.68 7.13328L19.2 3.74662C19.1467 3.42662 18.88 3.19995 18.56 3.19995H13.44C13.12 3.19995 12.8666 3.42662 12.8133 3.74662L12.3333 7.13328C11.5467 7.45328 10.8267 7.89328 10.1733 8.38662L6.98665 7.10662C6.69332 6.99995 6.35998 7.10662 6.19998 7.39995L3.65332 11.8266C3.49332 12.1066 3.54665 12.4533 3.81332 12.6399L6.51998 14.7466C6.45332 15.1466 6.39998 15.5866 6.39998 16C6.39998 16.4133 6.42665 16.8533 6.49332 17.2533L3.78665 19.36C3.54665 19.5466 3.47998 19.9066 3.62665 20.1733L6.18665 24.6C6.34665 24.8933 6.67998 24.9866 6.97332 24.8933L10.16 23.6133C10.8267 24.1199 11.5333 24.5466 12.32 24.8666L12.8 28.2533C12.8667 28.5733 13.12 28.8 13.44 28.8H18.56C18.88 28.8 19.1467 28.5733 19.1867 28.2533L19.6667 24.8666C20.4533 24.5466 21.1733 24.1199 21.8267 23.6133L25.0133 24.8933C25.3067 25 25.64 24.8933 25.8 24.6L28.36 20.1733C28.52 19.8799 28.4533 19.5466 28.2 19.36L25.52 17.2533ZM16 20.8C13.36 20.8 11.2 18.64 11.2 16C11.2 13.36 13.36 11.2 16 11.2C18.64 11.2 20.8 13.36 20.8 16C20.8 18.64 18.64 20.8 16 20.8Z" fill="white"/>
</g>
</g>
</g>
</g>
</g>
</g>
</g>
<defs>
<clipPath id="clip0_1_5">
<rect width="32" height="32" fill="white"/>
</clipPath>
<clipPath id="clip1_1_5">
<rect width="32" height="32" fill="white"/>
</clipPath>
</defs>
</svg>
